import React, { Component } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import axios from "axios";
import Serverurl from "./Apiurl";

import {
  Box,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItem,
  CssBaseline,
  Button,
  Badge,
  Menu,
  MenuItem
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import MenuIcon from '@mui/icons-material/Menu';
import SubdirectoryArrowRightIcon from '@mui/icons-material/ArrowRightAlt';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNoneOutlined';
import SummarizeIcon from '@mui/icons-material/Summarize'; // <-- added missing import
import smalllogo from './images/logo.jpg';
import innerAthalogo from './images/innerlogo.jpg';

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import businessImg from "./images/business.png";
import customerImg from "./images/customer.png";
import productImg from "./images/product.png";
import quotationImg from "./images/quotation.png";
import SettingsIcon from "@mui/icons-material/Settings";
import Paper from '@mui/material/Paper';
import signingBgImg from './images/signingbg.jpg'; 


const drawerWidth = 250;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const AppBar = styled(MuiAppBar, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: `${drawerWidth}px`,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  })
);

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

class AppLayout extends Component {
  constructor(props) {
    super(props);
   this.state = {
  open: false,
  menu1: false,
  menu2: false,
  menu3: false,
  anchorEl: null,
  menuopen: false,
  ldcnt: 0,
  bu_logo: "",
};

  }
  
  
  
  
componentDidMount() {
  const bu_id = localStorage.getItem("GBuserid");

  console.log("Logged-in GBuserid:", bu_id);

  if (!bu_id) {
    console.log("GBuserid not found");
    return;
  }

  axios
    .get(Serverurl + "ajaxbusiness.php?action=getall&bu_id=" + bu_id)
    .then((res) => {
      console.log("Business API response:", res.data);

      if (res.data && res.data.length > 0) {
        const business = res.data[0];

        console.log("Business logo filename:", business.bu_logo);

        const logo =
          business.bu_logo &&
          business.bu_logo !== "buiness.png" &&
          business.bu_logo !== "null"
            ? Serverurl + "uploads/" + business.bu_logo
            : Serverurl + "uploads/buiness.png";

        this.setState({
          bu_logo: logo,
        });
      } else {
        this.setState({
          bu_logo: Serverurl + "uploads/buiness.png",
        });
      }
    })
    .catch((error) => {
      console.error("Business logo API error:", error);

      this.setState({
        bu_logo: Serverurl + "uploads/buiness.png",
      });
    });
}


  handleDrawerOpen = () => {
    this.setState({ open: !this.state.open });
  };

  handleMenuClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
      menuopen: !this.state.menuopen,
    });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null, menuopen: false });
  };

  toggleMenu1 = () => {
    this.setState({ menu1: !this.state.menu1 });
  };

  toggleMenu2 = () => {
    this.setState({ menu2: !this.state.menu2 });
  };

  toggleMenu3 = () => {
    this.setState({ menu3: !this.state.menu3 });
  };

  handleCallleadcnt = (childData) => {
    this.setState({ ldcnt: childData });
  };

  render() {
	 
    const { open, menu1, anchorEl, menuopen, ldcnt } = this.state;
 const hideDashboardIcon = [
    "/Dashboard",
    "/Businessform",
    "/Productlist",
    "/Customerlist",
    "/Termsandconditions",
    "/Makequote",
    "/Quotationlist",
    "/Makepurchase",
    "/Purchaseorder",
	"/Makeinvoice",
	"/Invoicelist",
    "/Managerlist",
	"/PurchaseView",
	"/QuotationView",
	"/Settings",
	"/Profile",
	"/Businesschangepassword",
	"/QuotationSetting",
	"/PurchaseorderSetting",
	"/InvoiceSetting",
	"/AddCustomer","/AddTerms","/Addproduct","/purchase/view/:id",

   
  ].includes(this.props.location.pathname);
    return (

      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
		
		
		
       <AppBar position="absolute" open={open} sx={{ width: '100%', boxShadow: 'none', backgroundColor: '#ffffff' }}>
  {/* Top Logo Section */}
  <Box sx={{ padding: '8px 16px', backgroundColor: '#f0f4f7', display: 'flex', alignItems: 'center' }}>
    <IconButton
      color="inherit" 
      className="logobtn"
      aria-label="open drawer"
      edge="start"
      sx={{ mr: 2, ...(open && { display: 'none' }) }}
    >
     <img
  src={this.state.bu_logo || smalllogo}
  alt="Business Logo"
  style={{
    maxHeight: "35px",
    maxWidth: "120px",
    objectFit: "contain",
  }}
  onError={(e) => {
    e.target.src = smalllogo;
  }}
/>

    </IconButton>
  </Box>

  {/* Blue Header Bar */}
  <Toolbar 
    className="adminheaderbg"
    sx={{ 
      backgroundColor: '#0d4190', 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center',
      minHeight: '56px !important'
	
    }}
  >
    {/* Welcome Text Section */}
    <div className="accountlogin">
      <Typography variant="body1" sx={{ color: '#ffffff', fontWeight: 600, fontSize: '18px', lineHeight: 1.2 }}>
        Welcome
      </Typography>
      <Typography variant="caption" sx={{ color: '#fff', fontSize: '12px', textTransform: 'uppercase' }}>
        {localStorage.getItem('GBname') || 'GB'}
      </Typography>
    </div>

    {/* Right Menu & Controls Section */}
    <div className="accountsec">
      <ul className="linkslist" style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', alignItems: 'center', gap: '27px' }}>
        <li>
          <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
            <NavLink to="/Settings" className="submenus" style={{ color: '#ffffff', display: 'flex' }}>
              <SettingsOutlinedIcon />
            </NavLink>
          </Box>
        </li>

        <li>
          {/* Avatar / Dropdown Button */}
          <IconButton 
            onClick={this.handleMenuClick} 
            size="small"
            sx={{
              backgroundColor: '#0091ff',
              color: '#ffffff',
              width: 32,
              height: 32,
              fontSize: '14px',
              fontWeight: 'bold',
              '&:hover': { backgroundColor: '#0070cc' }
            }}
          >
            {(localStorage.getItem('GBname') || 'S').charAt(0).toUpperCase()}
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={menuopen}
            onClose={this.handleMenuClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '&:before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <MenuItem>
              <NavLink to="/Businesschangepassword" className="colorlink">
                Change Password
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink to="/Logout" className="colorlink">
                Logout
              </NavLink>
            </MenuItem>
          </Menu>
        </li>
      </ul>
    </div>
  </Toolbar>
</AppBar>
		

        {/* Drawer */}
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              boxSizing: 'border-box',
            },
          }}
          variant="persistent"
          anchor="left"
          className="slidebg"
          open={open}
        >
          <DrawerHeader className="headerlogo">
		  	<img src={innerAthalogo} />
            <IconButton onClick={this.handleDrawerOpen}>
              <ChevronRightIcon />
            </IconButton>
          </DrawerHeader>
        
         <List className="adminmenu"> 
            <ListItem>
              <NavLink to="/Businessform">
                <SubdirectoryArrowRightIcon className="iconvertical" /> Business Form
              </NavLink>
            </ListItem>
            <ListItem>
              <NavLink to="/Productlist">
                <SubdirectoryArrowRightIcon className="iconvertical" /> Product Management
              </NavLink>
            </ListItem>
            <ListItem>
              <NavLink to="/Customerlist">
                <SubdirectoryArrowRightIcon className="iconvertical" /> Customer Management
              </NavLink>
            </ListItem>
            <ListItem>
              <NavLink to="/Termsandconditions">
                <SubdirectoryArrowRightIcon className="iconvertical" /> Terms and Conditions
              </NavLink>
            </ListItem>
            <ListItem>
              <NavLink to="/Makequote">
                <SubdirectoryArrowRightIcon className="iconvertical" />Make Quote 
              </NavLink>
            </ListItem>
			 <ListItem>
              <NavLink to="/Quotationlist">
                <SubdirectoryArrowRightIcon className="iconvertical" />Quote Management
              </NavLink>
            </ListItem>
			  <ListItem>
              <NavLink to="/Makepurchase">
                <SubdirectoryArrowRightIcon className="iconvertical" />Make Purchase 
              </NavLink>
            </ListItem>
			 <ListItem>
              <NavLink to="/Purchaseorder">
                <SubdirectoryArrowRightIcon className="iconvertical" />Purchase  Order
              </NavLink>
            </ListItem>
			
			<ListItem>
              <NavLink to="/Makeinvoice">
                <SubdirectoryArrowRightIcon className="iconvertical" />Make Quote 
              </NavLink>
            </ListItem>
			
			<ListItem>
              <NavLink to="/Invoicelist">
                <SubdirectoryArrowRightIcon className="iconvertical" />Make Quote 
              </NavLink>
            </ListItem>
			
			 <ListItem>
              <NavLink to="/Managerlist">
                <SubdirectoryArrowRightIcon className="iconvertical" />ManagerList
              </NavLink>
            </ListItem>
			 <ListItem>
              <NavLink to="/CalendarServiceView">
                <SubdirectoryArrowRightIcon className="iconvertical" />Event Calender
              </NavLink>
            </ListItem>
			<div className="mobilesettings">
			 <ListItem>
              <NavLink to="/Businesschangepassword">
                <SubdirectoryArrowRightIcon className="iconvertical" />Change Password
              </NavLink>
            </ListItem>
			 <ListItem>
              <NavLink to="/Logout">
                <SubdirectoryArrowRightIcon className="iconvertical" />Logout
              </NavLink>
            </ListItem>
			</div>
          </List>
        </Drawer>

        {/* Main Content */}
        <Main open={open} className="drawerpad">
          <DrawerHeader />
          <div
  className="contentmain"
  style={{ position: "relative", minHeight: "100vh" }}
>

{/* {this.props.location.pathname !== "/Dashboard" && (
  <NavLink
    to="/Dashboard"
    style={{
      position: "absolute",
      left: "10px",
      top: "-15px",
	   bottom: "30px",
      zIndex: 10,
      color: "#0d4190",
      textDecoration: "none",
    }}
  >
    <ArrowBackIcon
      sx={{
        fontSize: 40,
        cursor: "pointer",
        "&:hover": {
          color: "#0d47a1",
        },
      }}
    />
  </NavLink>
  )} */}

            <Outlet />
          </div>
		  
		  
		  
		  
 {/* FOOTER DASHBOARD NAVIGATION MENU */}

{/* FOOTER DASHBOARD NAVIGATION MENU */}

{this.props.location.pathname !== "/Dashboard" && (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      position: 'relative',
      zIndex: 2,
      marginBottom: '-28px',
    }}
  >
    <Paper
      elevation={0}
      sx={{
        bgcolor: '#ffffff',
        borderRadius: '20px',
        px: 1.5,
        py: 0.8,
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: '90%',
        maxWidth: '500px',
		padding: '0px 12px',
        boxShadow: '0px 4px 12px rgba(0,0,0,0.15)',
      }}
    >
      {[
        { title: 'Home', path: '/Dashboard', img: businessImg },
        { title: 'Customers', path: '/Customerlist', img: customerImg },
        { title: 'Products', path: '/Productlist', img: productImg },
        { title: 'Quotes', path: '/Quotationlist', img: quotationImg },
		  ...(localStorage.getItem("GBuserid") !== "1"
    ? [
        {
          title: 'Invoice',
          path: '/Invoicelist',
          img: quotationImg 
        }
      ]
    : []),
	
        { title: 'Settings', path: '/Settings', icon: <SettingsIcon sx={{ fontSize: 26 }} /> },
      ].map((item, index) => {
        return (
          <NavLink key={index} to={item.path} style={{ textDecoration: 'none' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#0d326f',
                bgcolor: 'transparent',
                borderRadius: '14px',
                p: 1.2,
                transition: 'all 0.2s ease',
                '&:hover': {
                  bgcolor: '#0d326f', 
                  color: '#ffffff',   
                  '& img': {
                    filter: 'brightness(0) invert(1)', 
                  },
                },
              }}
            >
              {item.icon ? (
                item.icon
              ) : (
                <img
                  src={item.img}
                  alt={item.title}
                  style={{
                    width: 45,
                   
                    transition: 'filter 0.2s ease',
                  }}
                />
              )}
            </Box>
          </NavLink>
        );
      })}
    </Paper>
  </Box>
)}

<div
  className="footerbg"
  style={{
    position: 'relative',
    zIndex: 1,
    paddingTop: this.props.location.pathname !== "/Dashboard" ? '38px' : '5px',
  }}
>
  <p>© Copyright {(new Date().getFullYear())} Global Buzz, All Rights Reserved.</p>
</div>
        </Main>
      </Box>
    );
  }
}

function AppLayoutWrapper() {
  const location = useLocation();
  return <AppLayout location={location} />;
}

export default AppLayoutWrapper;
